@if (faultStatus) {
  <span [ngClass]="badgeStyle"
        [ngStyle]="{'font-size': fontSize}">
    {{ faultStatus | titlecase | messageTranslate }}
  </span>
}
